import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import ConfigProps from "../constants/configProps";
import ConfigPropService from "./configPropService";

function isTrue(configPropId: string) {
  return ConfigPropService.get([configPropId]).pipe(
    map(
      (value: Record<string, string | boolean | number>) =>
        value[configPropId] === true ||
        value[configPropId] === "Yes" ||
        value[configPropId] === "yes" ||
        value[configPropId] === 1
    )
  );
}

function isFalse(configPropId: string) {
  return isTrue(configPropId).pipe(map((value) => value === false));
}

function anyCompare(
  configPropIds: string[],
  compareCallback: (value: string) => boolean
) {
  return ConfigPropService.get(configPropIds).pipe(
    map((value) => {
      for (let i = 0; i < configPropIds.length; i++) {
        const result = compareCallback(value[configPropIds[i]]);
        if (result) {
          return result;
        }
      }

      return false;
    })
  );
}

function compare(
  configPropId: string,
  compareCallback: (value: string) => boolean
) {
  return ConfigPropService.get([configPropId]).pipe(
    map((value) => {
      return compareCallback(value[configPropId]);
    })
  );
}

const OIPermissionLevel: Record<string, number> = {
  None: 0,
  ViewFiles: 10,
  "ViewFiles&AR": 20,
  ViewFiles_AR_Payment: 30,
};

const MenuItemService = {
  displayAccountStatement: () => {
    /*public enum OIPermissionLevel
    {
        None = 0,
        ViewFiles = 10,
        ViewFilesAR = 20,
        ViewFilesARPayment = 30
    }*/
    return compare(ConfigProps.OI_Permission_ID, (value) => {
      return OIPermissionLevel[value]
        ? OIPermissionLevel[value] >= OIPermissionLevel["ViewFiles&AR"]
        : false;
    });
  },
  onlineInvoicingSignUpUrl: () => {
    return compare(ConfigProps.OI_Permission_ID, (value) => {
      return !value || OIPermissionLevel[value] === OIPermissionLevel.None;
    });
  },
  displaySignOut: () => {
    return isFalse(ConfigProps.Use_Punchout);
  },
  displayHistory: () => {
    return compare(ConfigProps.OI_Permission_ID, (value) => {
      return OIPermissionLevel[value]
        ? OIPermissionLevel[value] >= OIPermissionLevel.ViewFiles
        : false;
    });
  },
  displayAdvancedReporting: () => {
    return isTrue(ConfigProps.View_Reports);
  },
  displayUsers: () => {
    return isTrue(ConfigProps.Manage_Users);
  },
  displayGroups: () => {
    return isTrue(ConfigProps.Manage_Groups);
  },
  displayAddresses: () => {
    return forkJoin({
      manageShipping: compare(ConfigProps.Manage_Shipping_Addresses, (value: string) => {
        return !!value && value.toLowerCase() !== "none";
      }),
      editBilling: isTrue(ConfigProps.EditBillingAddress)
    });
  },
  displayCreditCards: () => {
    /*        public enum mbsPermissionLevel
        {
            None = 0,
            View = 10,
            Edit = 20,
            Create = 30,
            Full = 40
        }*/
    return anyCompare(
      [
        ConfigProps.Manage_Personal_Credit_Card,
        ConfigProps.Manage_Account_Credit_Card,
      ],
      (value) => {
        return !!value && value.toLowerCase() !== "none";
      }
    );
  },
  displayManageAch: () => {
    return compare(ConfigProps.Manage_Personal_Checking, (value) => {
      return !!value && value.toLowerCase() !== "none";
    });
  },
  displayBudgets: () => {
    return isTrue(ConfigProps.View_Budgets_Page);
  },
  displayOrderApprovalsAndWorkflows: () => {
    return isTrue(ConfigProps.Manage_Order_Approval);
  },
  displayBillingCycle: () => {
    return compare(ConfigProps.OI_Permission_ID, (value) => {
      return OIPermissionLevel[value]
        ? OIPermissionLevel[value] >= OIPermissionLevel["ViewFiles&AR"]
        : false;
    });
  },
  displayReturnsCenter: () => {
    return isTrue(ConfigProps.Permit_Online_Returns);
  },
  displaySavedCarts: () => {
    return isTrue(ConfigProps.Display_Save_Cart_Links);
  },
  displayAccountCenterDashboard: () => {
    return isTrue(ConfigProps.DisplayAccountCenterDashboardLink);
  },
  displayAccountAndSettingsLink: () => {
    return isTrue(ConfigProps.EnableAccountAndSettingsLink);
  },
  displayRecentlyViewed: () => {
    return isTrue(ConfigProps.DisplayRecentlyViewedLink);
  },
  displayRecurringPayments: () => {
    return compare(ConfigProps.ManageRecurringPayments, (value) => {
      return !!value && value.toLowerCase() !== "none";
    });
  },
  displayEasyReorder: () => {
    return isTrue(ConfigProps.EnableMyWBRecentItemsPage);
  },
  displayOrders: () => {
    return isTrue(ConfigProps.DisplayOrderHistoryLink);
  },
  displayDashboard: () => {
    return isTrue(ConfigProps.displayDashboard);
  },
  displayQuickOrderLinks: () => {
    return isTrue(ConfigProps.DisplayQuickOrderLinks);
  },
};

export default MenuItemService;
